import { FC } from "react";
import { useForm } from "react-hook-form";

interface Props {
  placeholder: string;
  onSubmited: (keyword: string) => void;
}

interface FormInput {
  keyword: string;
}

const SearchBarSp: FC<Props> = ({ placeholder, onSubmited }): JSX.Element => {
  const { register, handleSubmit } = useForm<FormInput>();

  const onSubmit = (data: FormInput) => {
    if (data.keyword) {
      onSubmited(data.keyword);
    }
  };

  return (
    <form
      className="flex space-x-4 leading-none"
      onSubmit={handleSubmit(onSubmit)}
    >
      <input
        placeholder={placeholder}
        type="text"
        className="flex-1 laptop:text-xs text-base w-full"
        defaultValue={""}
        {...register("keyword")}
        autoComplete="off"
      />
      <button
        type="submit"
        className="block bg-black text-white p-8 rounded-sm text-base"
      >
        <i className="Icon icon-Search" />
      </button>
    </form>
  );
};

export default SearchBarSp;
